// extracted by mini-css-extract-plugin
module.exports = {"spinner":"Spinner-module__spinner___3EJE8","rotate":"Spinner-module__rotate___1lAy3","path":"Spinner-module__path___KMwSz","dash":"Spinner-module__dash___1W9UH"};